<template>
    <div>
        <or-layout>
            <h3 class="page">
                机构信息
                <a-button type="primary" icon="left" @click="goPage">返回</a-button>
            </h3>
            <div class="main">
                <a-row class="row" :gutter="16">
                    <a-col :span="16">
                        <h2 class="title">{{org_info.info.name}}</h2>
                        <div class="row">机构管理员:{{org_info.info.management}}</div>
                    </a-col>
                    <a-col :span="2">
                        <a-statistic title="校区数" :value="org_info.studentcount" />
                    </a-col>
                    <a-col :span="2">
                        <a-statistic title="班级数" :value="org_info.missioncount" />
                    </a-col>
                    <a-col :span="2">
                        <a-statistic title="老师数" :value="org_info.cancelv"></a-statistic>
                    </a-col>
                    <a-col :span="2">
                        <a-statistic title="学生数" :value="org_info.zhengquelv"></a-statistic>
                    </a-col>
                </a-row>
                <a-tabs class="row" type="card" :activeKey="currTabKey" @change="tabsChange">
                    <a-tab-pane tab="校区" key="campus">
                        <a-button type="primary" @click="addCampus" style="margin-bottom: 10px;">新增校区
                        </a-button>
                        <a-table :dataSource="campusList" :rowKey="item => item.id" :pagination="false" bordered>
                            <a-table-column key="name" title="校区名字" data-index="name" />
                            <a-table-column key="nickname" title="校长" data-index="nickname" />
                            <a-table-column key="mobile" title="联系电话" data-index="mobile" />
                            <a-table-column key="address" title="地址" data-index="address" />
                            <a-table-column key="active" width="180px" title="操作">
                                <template slot-scope="item">
                                    <a-button v-if="item.status==0" @click="changeCampusStatus({id:item.id,status:1})"
                                        class="active_btn"  type="link">启用
                                    </a-button>
                                    <a-button v-if="item.status==1" @click="changeCampusStatus({id:item.id,status:0})"
                                        class="active_btn"  type="link">禁用
                                    </a-button>
                                    <!--<a-button v-if="item.status==1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑-->
                                    <!--</a-button>-->
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane tab="班级" key="grade">
                        <a-form layout="inline">
                            <a-form-item>
                                <a-select defaultActiveFirstOption v-model="searchFrom.campus_id" placeholder="校区"
                                    style="width: 150px;">
                                    <a-select-option :key="undefined" :value="undefined">全部</a-select-option>
                                    <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{item.name}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item>
                                <a-select v-model="searchFrom.course_id" placeholder="课程" style="width: 120px;">
                                    <a-select-option :key="undefined" :value="undefined">全部</a-select-option>
                                    <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{item.name}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            
                            <a-form-item>
                                <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                                    <a-select-option v-for="(item) in nianjiList" :key="item.id" :value="item.id">{{item.name}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item>
                                <a-input placeholder="班级名称" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                            </a-form-item>
                            <a-form-item>
                                <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                            </a-form-item>
                        </a-form>
                        <a-table :dataSource="gradeList" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                            @change="onPaginationChange" bordered>

                            <a-table-column key="gradename" title="年级" data-index="gradename" />
                            <a-table-column key="name" title="班级" data-index="name" />
                            <a-table-column key="campusname" title="校区" data-index="campusname" />
                            <a-table-column key="coursename" title="课程包" data-index="coursename" />
                            <a-table-column key="amount" title="计划人数" data-index="amount" />
                            <a-table-column key="code" title="班级码" data-index="code" />
                            <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                            <a-table-column key="teacher" title="任课老师" data-index="teacher" />

                            <a-table-column key="type" title="班型">
                                <template slot-scope="item">
                                    <span v-if="item.type==0">培优班</span>
                                    <span v-if="item.type==1">提高班</span>
                                    <span v-if="item.type==2">英才班</span>
                                    <span v-if="item.type==3">1对1VIP班</span>
                                     <span v-if="item.type==4">体验课</span>
									  <span v-if="item.type==5">冲刺班</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="opening" title="开班状态">
                                <template slot-scope="item">
                                    <span v-if="item.opening==0">未开班</span>
                                    <span v-if="item.opening==1">已开班</span>
                                    <span v-if="item.opening==2">已结班</span>
                                </template>
                            </a-table-column>
                            <!--<a-table-column key="status" width="100px;" title="状态">-->
                            <!--<template slot-scope="item">-->
                            <!--<span v-if="item.status==1">可用</span>-->
                            <!--<span v-if="item.status==0">已禁用</span>-->
                            <!--</template>-->
                            <!--</a-table-column>-->
                            <a-table-column key="active" title="操作">
                                <template slot-scope="item">
                                  <!--  <router-link :to="{path:'/orgquadinfo',query:{id:item.id}}">查看详情</router-link> -->
                                     <Squadinfo v-bind:itemdata="item"></Squadinfo>
                                    <a-button v-if="item.status==0" @click="changeSquadStatus({id:item.id,status:1,pid:item.pid})"
                                        class="active_btn" s type="link">启用
                                    </a-button>
                                    <a-button v-if="item.status==1" @click="changeSquadStatus({id:item.id,status:0,pid:item.pid})"
                                        class="active_btn"  type="link">禁用
                                    </a-button>
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane tab="老师" key="teacher">
                        <a-button type="primary" @click="addTeacher" style="margin-bottom: 10px;">添加老师
                        </a-button>
                        <a-table :dataSource="teacherList" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                            @change="onPaginationChange" bordered>
                            <a-table-column key="username" title="账号" data-index="username" />
                            <a-table-column key="nickname" title="姓名" data-index="nickname" />
                            <a-table-column key="mobile" title="手机号码" data-index="mobile" />
                            <a-table-column key="email" title="电子邮件" data-index="email" />
                            <a-table-column key="create_time" title="创建时间" data-index="create_time" />
                            <a-table-column key="status" title="状态">
                                <template slot-scope="item">
                                    <span v-if="item.status==1">可用</span>
                                    <span v-if="item.status==0">已禁用</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="active" title="操作">
                                <template slot-scope="item">
                                    <a-button v-if="item.status==0" @click="changeTeacherStatus({id:item.id,status:1 })"
                                        class="active_btn" size="small" type="link">启用
                                    </a-button>
                                    <a-button v-if="item.status==1" @click="changeTeacherStatus({id:item.id,status:0 })"
                                        class="active_btn" size="small" type="link">禁用
                                    </a-button>
                                    <a-button @click="teacherDelBtn({admin_id:item.id })" class="active_btn" size="small"
                                        type="link">移出
                                    </a-button>
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                     <a-tab-pane tab="数据配置" key="sjpz">
                         <orgbasicconfig v-bind:org_id="org_id"></orgbasicconfig>
                     </a-tab-pane>
                    <a-tab-pane tab="数据分析" key="sjfx">
                        <a-form layout="inline">
                            <a-form-item>
                                
                                <a-select  v-model="currentGradeId"  placeholder="年级" allowClear=true
                                    style="width: 330px; padding-left: 20px;">
                                    <a-select-option v-for="item in gradeData" :key="item.id">
                                       {{item.name}}
                                    </a-select-option>
                                </a-select> 
                                
                             <!--  <a-select :default-value="null" placeholder="年级" v-model="currentGradeId" >
                                    <a-select-option :value="null" :key="null">所有年级</a-select-option>
                                    <template v-for="item in gradeData">
                                        <a-select-option :value="item.id" :key="item.id">{{item.name}}
                                        </a-select-option>
                                    </template>
                                </a-select> -->
                            </a-form-item>
                             <a-form-item>
                            <a-select  v-model="currentMissiontypeId" mode="multiple" placeholder="任务类型"
                                style="width: 330px; padding-left: 20px;">
                                <a-select-option v-for="item in missiontype" :key="item.id">
                                   {{item.name}}
                                </a-select-option>
                            </a-select>
                               </a-form-item>
                            <a-form-item>
                                <a-button type="primary" icon="search" htmlType="submit" @click="searchTaskData">查询
                                </a-button>
                            </a-form-item>
                        </a-form>
                        <a-table :data-source="taskData" :pagination="taskPageInfo" :row-key="item=>item.id" @change="onTaskPageChange"
                            style="margin-top: 1rem;" bordered>
                            <a-table-column key="name" title="任务名称">
                                <template slot-scope="item">
                                    <a-tag color="blue">{{item.typename}}</a-tag>
                                    {{item.name}}
                                </template>
                            </a-table-column>
                            <a-table-column key="grade" data-index="gradename" title="年级"></a-table-column>
                            <a-table-column key="action" style="width: 3rem;">
                                <template slot-scope="item">
                                    <router-link :to="{path: '/task-statistics', query: {tid: item.id, oid: org_id,currentGradeId:currentGradeId}}">统计分析
                                    </router-link>
                                    | <a @click="getsquadlistbymission(item.id)">生成报表</a>
                                    | <a @click="getmissionreportlist(item.id)">查看报表</a>
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane tab="设置" key="settings">
                        <a-button @click="makeOrgMiss" :loading="loading" type="primary">生成全部任务</a-button>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <a-modal :visible="campusVisible" title="校区信息" @ok="campusModalSave" :destroyOnClose="true" @cancel="modalCancel">
                <a-form>
                    <!--<a-input type="hidden" v-model="campusForm.id" />-->
                    <a-form-item>
                        <a-input v-model="campusForm.name" placeholder="校区名字" />
                    </a-form-item>
                    <a-form-item>
                        <a-input v-model="campusForm.address" placeholder="地址" />
                    </a-form-item>
                    <a-form-item>
                        <a-input v-model="campusForm.gps" placeholder="GPS位置" />
                    </a-form-item>
                    <a-form-item>
                        <or-upload v-model="campusForm.campus_logo" mode="image" @input="uploadfile" button-text="上传校区图标" />
                    </a-form-item>
                    <a-form-item>
                        <a-select optionFilterProp="children" show-search v-model="campusForm.admin_id" placeholder="管理员"
                            style="width: 100%;">
                            <a-select-option v-for="item in  adminList" :key="item.id" :value="item.id">{{item.nickname}}-{{item.mobile}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal :visible="teacherVisible" title="教师" @ok="teacherSave" @cancel="modalCancel">
                <a-form>
                    <a-form-item>
                        <a-input v-model="teacherForm.nickname" placeholder="姓名" />
                    </a-form-item>
                    <a-form-item>
                        <a-input v-model="teacherForm.email" placeholder="邮箱" />
                    </a-form-item>
                    <a-form-item>
                        <a-input v-model="teacherForm.mobile" placeholder="手机号码" />
                    </a-form-item>
                    <a-form-item>
                        <a-select mode="multiple"  placeholder="角色" v-model="teacherForm.role_ids">
                            <a-select-option v-for="item in role" :key="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-input v-model="teacherForm.password" placeholder="登录密码" />
                </a-form>
            </a-modal>
            <a-modal :centered="true" :width="800" :visible="mission_squad_visible" :destroyOnClose="true"
                :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="预览报表" okText="预览报表" cancelText="关闭"
                @ok="createmissionreport" @cancel="mission_squad_visible=false">
                <a-table :dataSource="mission_squadlist" :rowKey="item => item.id" :pagination="false" :rowSelection="{onChange:onCheckChange}">
                    <a-table-column key="campusname" title="校区" data-index="campusname" />
                    <a-table-column key="name" title="班级" data-index="name" />
                    <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                    <a-table-column key="teacher" title="教师" data-index="teacher" />
                    <!--<a-table-column key="show_report" title="查看报告">-->
                    <!--<template slot-scope="item">-->
                    <!--<a @click="show_repost(item.id,)">查看报告</a>-->
                    <!--</template>-->
                    <!--</a-table-column>-->
                </a-table>
            </a-modal>
            <a-modal :centered="true" :footer="null" :width="'80%'" :visible="show_report_visible" :destroyOnClose="true"
                :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="报表列表" okText="报表列表" cancelText="关闭"
                @cancel="show_report_visible=false">
                <a-table :dataSource="show_report_list" :rowKey="item => item.id" :pagination="false">
                    <a-table-column :width="300" key="mission_name" title="任务名字" data-index="mission_name" />
                    <a-table-column key="name" title="报告名字" data-index="name" />
                    <a-table-column key="create_time" title="时间" data-index="create_time" />
                    <a-table-column key="pagecountscore" title="总分" data-index="pagecountscore" />
                    <a-table-column key="page_difficulty" title="困难" data-index="page_difficulty" />
                    <a-table-column key="page_medium" title="中等" data-index="page_medium" />
                    <a-table-column key="page_simple" title="简单" data-index="page_simple" />
                    <a-table-column key="real_grade_avg_score" title="真实平均" data-index="real_grade_avg_score" />
                    <a-table-column key="virtual_grade_avg_score" title="虚拟平均" data-index="virtual_grade_avg_score" />
                    <a-table-column key="real_grade_tallest_score" title="真实最高" data-index="real_grade_tallest_score" />
                    <a-table-column key="virtual_grade_tallest_score" title="虚拟最高" data-index="virtual_grade_tallest_score" />
                    <a-table-column key="test_ratio" title="参测率" data-index="test_ratio" />
                    <a-table-column key="opt" title="默认">
                        <template slot-scope="item">
                            <a-switch checked-children="是" un-checked-children="否" :loading="loading" @change="fun=>changeDefault(fun,item.id)"
                                :defaultChecked="item.ifdefault==1" />
                        </template>
                    </a-table-column>
                    <a-table-column key="del" title="操作">
                        <template slot-scope="item">
                            <a-button :loading="loading" @click="delReport(item.id)">删除</a-button>
                        </template>
                    </a-table-column>
                </a-table>
                <div style="text-align: right;margin-top: 1rem;">
                    <a-button type="primary" @click="show_report_visible=false">关闭</a-button>
                </div>
            </a-modal>
            <a-modal :centered="true" :width="500" :visible="edit_report_info" :destroyOnClose="true" :confirmLoading="loading"
                :maskClosable="false" :keyboard="false" title="生成报表" okText="生成报表" cancelText="关闭" @ok="makeReport"
                @cancel="edit_report_info=false">
                <a-form :label-col="{ span: 8}" :wrapper-col="{ span: 10}">
                    <a-form-item label="年级">
                        <a-input v-model="report_info.grade_name" :disabled="true" placeholder="年级" />
                    </a-form-item>
                    <a-form-item label="试卷总分">
                        <a-input v-model="report_info.pagecountscore" :disabled="true" placeholder="试卷总分" />
                    </a-form-item>
                    <a-form-item label="困难题目分数">
                        <a-input v-model="report_info.page_difficulty" :disabled="true" placeholder="困难题目分数" />
                    </a-form-item>
                    <a-form-item label="中等题目分数">
                        <a-input v-model="report_info.page_medium" :disabled="true" placeholder="中等题目分数" />
                    </a-form-item>
                    <a-form-item label="简单题目总分">
                        <a-input v-model="report_info.page_simple" :disabled="true" placeholder="简单题目总分" />
                    </a-form-item>
                    <a-form-item label="真实平均分">
                        <a-input v-model="report_info.real_grade_avg_score" :disabled="true" placeholder="真实平均分" />
                    </a-form-item>
                    <a-form-item label="虚拟平均分">
                        <a-input v-model="report_info.virtual_grade_avg_score" placeholder="虚拟平均分" />
                    </a-form-item>
                    <a-form-item label="真实最高分">
                        <a-input v-model="report_info.real_grade_tallest_score" :disabled="true" placeholder="真是最高分" />
                    </a-form-item>
                    <a-form-item label="虚拟最高分">
                        <a-input v-model="report_info.virtual_grade_tallest_score" placeholder="虚拟最高分" />
                    </a-form-item>
                    <a-form-item label="测试完成率">
                        <a-input v-model="report_info.test_ratio" :disabled="true" placeholder="测试完成率" />
                    </a-form-item>
                    <a-form-item label="报告名称">
                        <a-input v-model="report_info.name" placeholder="报告名称" />
                    </a-form-item>
                </a-form>
            </a-modal>
        </or-layout>
    </div>
</template>


<script>
    import moment from "moment";
    import OrUpload from "@/components/upload";
    import Squadinfo from '@/views/basic/orgquadinfomodel.vue';
    import orgbasicconfig from '@/views/basicconfig/orgbasicconfig.vue';
    export default {
        components: {
            OrUpload,
            Squadinfo,
            orgbasicconfig
        },
        data() {
            return {
                 role:[],
                edit_report_info: false,
                report_info: {},
                show_report_visible: false,
                curr_mission_id: undefined,
                mission_squadlist: [],
                mission_squad_visible: false,
                select_mission_squad_list: [],
                show_report_list: [],
                currTabKey: "",
                org_id: undefined,
                pageinfo: {
                    total: 1,
                    current: 1,
                    pageSize: 10
                },
                loading: false,
                squad_id: "",
                squadChapterList: [],
                org_info: {
                    info: {},
                    data: {},
                },
                campusList: [],
                courseList: [],
                gradeList: [],
                nianjiList:[],
                adminList: [],
                teacherList: [],
                squadMissionList: [],
                mission_type: "",
                campusVisible: false,
                campusForm: {
                    id: undefined,
                    name: undefined,
                    campus_logo: undefined,
                    gps: undefined,
                    address: undefined,
                    admin_id: undefined,
                    org_id: undefined,
                },
                searchFrom: {
                    org_id: undefined,
                    keyword: undefined,
                    grade_id:undefined,
                    course_id: undefined,
                },
                teacherVisible: false,
                teacherForm: {
                    nickname: undefined,
                    email: undefined,
                    mobile: undefined,
                    password: undefined,
                    org_id: undefined,
                },
                currentGradeId: null,
                currentMissiontypeId:[],
                taskData: [],
                taskPageInfo: {},
                gradeData: [],
                missiontype:[],
            };
        },
        mounted() {
            this.org_id = this.$route.query.id;
            this.searchFrom.org_id = this.org_id;
            this.campusForm.org_id = this.org_id;
            this.teacherForm.org_id = this.org_id;
            this.getAdminList();
            // this.getCourseList();
            this.getCampusList(this.org_id);
            this.getCourseList(this.org_id);
            this.getOrgInfo(this.org_id);
            this.getNianjiList();
            if (this.$route.query.currentGradeId) {
                this.currentGradeId = this.$route.query.currentGradeId;
                this.tabsChange("sjfx");
            } else {
                this.tabsChange("campus");
            }
        },

        methods: {
            //报表模块开始

            //修改默认报表

            delReport(id) {
                this.loading = true;
                this.$axios
                    .post("/api/UserReport/dellmissionreport", {
                        data: {
                            id: id
                        }
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getmissionreportlist(this.curr_mission_id);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            async loadrole() {
                const res = await this.$axios.post("/api/AuthRole/getrolelistorg");
                this.role = res.data;
            },
            changeDefault(checked, id) {
                let ifdefault = checked ? 1 : 0;
                this.loading = true;
                this.$axios
                    .post("/api/UserReport/setdefaultreport", {
                        data: {
                            ifdefault: ifdefault,
                            id: id
                        }
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            onCheckChange(li) {
                this.select_mission_squad_list = li;
            },
            getsquadlistbymission(mission_id) {
                this.select_mission_squad_list = [];
                this.curr_mission_id = mission_id;
                this.$axios
                    .post("/api/UserReport/getsquadlistbymission", {
                        data: {
                            org_id: this.org_id,
                            mission_id: mission_id
                        }
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.mission_squadlist = res.data;
                            this.mission_squad_visible = true;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            makeReport() {
                this.report_info.squad_list = this.select_mission_squad_list.join(",");
                this.$axios
                    .post("/api/UserReport/createvirtualmissionreport", {
                        data: this.report_info
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.$success({
                                title: "完成",
                                content: "任务报告生成成功",
                                okText: "确定",
                            });
                            this.edit_report_info = false;
                            this.show_report_visible = false;
                            this.mission_squad_visible = false;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });

            },
            createmissionreport() {
                if (this.select_mission_squad_list.length < 1) {
                    this.$error({
                        title: "错误",
                        content: "最少选择一个班级进行任务生成",
                        okText: "确定",
                    });
                    return false;
                }
                this.loading = true;
                this.$axios
                    .post("/api/UserReport/createmissionreport", {
                        data: {
                            org_id: this.org_id,
                            mission_id: this.curr_mission_id,
                            squad_ids: this.select_mission_squad_list
                        }
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.report_info = res.data;
                            this.report_info.test_ratio = this.report_info.test_ratio * 100;
                            this.edit_report_info = true;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });

            },
            getmissionreportlist(mission_id) {
                this.curr_mission_id = mission_id;
                this.$axios
                    .post("/api/UserReport/getmissionreportlist", {
                        data: {
                            org_id: this.org_id,
                            mission_id: mission_id
                        }
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.show_report_list = res.data;
                            this.show_report_visible = true;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },

            //报表模块结束

            makeOrgMiss() {
                this.loading = true;
                this.$axios
                    .post("/api/OrgSquad/setsquadmissionlist", {
                        data: {
                            org_id: this.org_id
                        }
                    })
                    .then(res => {
                        this.loading = false;
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                        } else {
                            this.$success({
                                title: "正确",
                                content: "任务生成完成",
                                okText: "确定"
                            });
                        }
                    })
                    .catch(err => {
                        this.loading = true;
                        console.error(err);
                    });
            },
            searchTaskData() {
                this.taskPageInfo = {};
                this.loadTaskData();
            },
            async loadGradeData() {
                const res = await this.$axios.post("/api/BasicGrade/index");
                this.gradeData = res.data.data;
            },
            async loadMissiontypeData() {
                const res = await this.$axios.post("/api/BasicMissionType/index");
                this.missiontype = res.data.data;
            },
            async loadTaskData() {
                const res = await this.$axios.post(
                    "/api/BasicMission/getorgmisssion", {
                        data: {
                            grade_id: this.currentGradeId,
                             type_id: this.currentMissiontypeId
                        },
                        pageinfo: this.taskPageInfo,
                    }
                );
                this.taskData = res.data.data;
                this.taskPageInfo = res.data.pageinfo;
            },
            onTaskPageChange(pageinfo) {
                this.taskPageInfo = pageinfo;
                this.loadTaskData();
            },
            tableSearch() {
                this.getGradeList();
            },
            getCourseList() {
                this.$axios
                    .post("/api/BasicCourse/index", {
                        pageinfo: {
                            pageSize: 999
                        }
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.courseList = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            getNianjiList() {
                this.$axios
                    .post("/api/BasicGrade/index", {
                        pageinfo: {
                            pageSize: 999
                        }
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.nianjiList = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            
            addCampus() {
                this.campusVisible = true;
            },
             getAdminList() {
      this.$axios
        .post("/api/Admin/index",{
          data: {org_id: this.org_id},
          pageinfo:{
              pageSize:'999',
          }
      })

        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.adminList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    }, 
            tableAdd() {
                this.form = {};
                this.visible = true;
            },
            changeTeacherStatus(data) {
                this.$axios
                    .post("/api/Admin/edit", {
                        data
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getTeacherList();
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            addTeacher() {
                this.teacherVisible = true;
                 this.loadrole();
            },
            teacherDelBtn(data) {
                let _this = this;
                data.org_id = this.org_id;
                this.$confirm({
                    title: "移出教师",
                    content: "确认移出当前教师吗?",
                    okText: "确认",
                    cancelText: "取消",
                    onOk: function() {
                        _this.$axios
                            .post("/api/OrgCampus/delteacher", {
                                data
                            })
                            .then((res) => {
                                if (res.code != 200) {
                                    _this.$error({
                                        title: "错误",
                                        content: res.msg,
                                        okText: "确定",
                                    });
                                } else {
                                    _this.getTeacherList();
                                }
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                    },
                });
            },
            changeSquadStatus(data) {
                this.$axios
                    .post("/api/OrgSquad/edit", {
                        data
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getGradeList();
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            changeCampusStatus(data) {
                this.$axios
                    .post("/api/OrgCampus/enable", {
                        data,
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getCampusList(this.org_id);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            modalCancel() {
                this.campusVisible = false;
                this.teacherVisible = false;
            },
            getGradeList() {
                this.$axios
                    .post("/api/OrgSquad/getorgsquad", {
                        data: this.searchFrom,
                        pageinfo: this.pageinfo,
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.gradeList = res.data.data;
                            this.pageinfo = res.data.pageinfo;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            getTeacherList() {
                this.$axios
                    .post("/api/OrgCampus/getteacher", {
                        pageinfo: this.pageinfo,
                        data: this.teacherForm,
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.teacherList = res.data.data;
                            this.adminList = res.data.data;
                            this.pageinfo = res.data.pageinfo;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            tabsChange(key) {
                this.currTabKey = key;
                this.pageinfo = {
                    total: 1,
                    current: 1,
                    pageSize: 10
                };
                switch (key) {
                    case "campus":
                        this.getCampusList(this.org_id);
                        break;
                    case "grade":
                        this.getGradeList();
                        break;
                    case "teacher":
                        this.getTeacherList();
                        break;
                    case "sjfx":
                        this.loadTaskData();
                        this.loadGradeData();
                        this.loadMissiontypeData();
                        break;
                    default:
                        break;
                }
            },

            //把学生从指定班级移出
            //获取机构信息
            getOrgInfo(id) {
                this.$axios
                    .post("/api/OrgOrganization/getinfo", {
                        data: {
                            org_id: id,
                        },
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.org_info = res.data;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            onPaginationChange(item) {
                this.pageinfo.current = item.current;
                switch (this.currTabKey) {
                    case "campus":
                        this.getCampusList(this.org_id);
                        break;
                    case "grade":
                        this.getGradeList();
                        break;
                    case "teacher":
                        this.getTeacherList();
                        break;
                    case "sjfx":
                        this.loadTaskData();
                        this.loadGradeData();
                        break;
                    default:
                        break;
                }
            },
            uploadfile() {},
            //获取机构下的校区
            getCampusList(id) {
                this.$axios
                    .post("/api/OrgCampus/getorgcampuslist", {
                        data: {
                            org_id: id
                        },
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.campusList = res.data;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            teacherSave() {
                this.$axios
                    .post("/api/OrgCampus/addteacher", {
                        data: this.teacherForm
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getTeacherList();
                            this.teacherVisible = false;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            campusModalSave() {
                this.$axios
                    .post("/api/OrgCampus/add", {
                        data: this.campusForm
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getCampusList(this.org_id);
                            this.campusVisible = false;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            goPage() {
                this.$router.push("/orgorganization");
            },
            moment,
        },
    };
</script>


<style lang="less" scoped>
    .main {
        margin-top: 1.5rem;
    }

    .row {
        margin-top: 1rem;
    }

    .title {
        font-weight: 700;
        font-family: 微软雅黑, tahoma;
    }

    .page {
        display: flex;
        justify-content: space-between;
    }
</style>
